$(function () {
    $().UItoTop({ easingType: 'easeOutQuart' });
});
